import { memo, type PropsWithChildren } from 'react';

export type SharePermissionSectionProps = {
  title: string;
};

export const SharePermissionSection = memo(({ children, title }: PropsWithChildren<SharePermissionSectionProps>) => (
  <div className="flex flex-col gap-3">
    <p className="font-semibold text-12 text-grey-10">{title}</p>
    {children}
  </div>
));

SharePermissionSection.displayName = 'SharePermissionSection';
